import React from "react";
import { useIntl } from "react-intl";
import { alpha } from "@mui/material/styles";
import { AlertTriangle, CheckCircle, X } from "@piiqtechnologies/svg-icons";
import { PeekBox, PeekCircularProgress, PeekIconButton, PeekLink, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import { ExportErrorReason, ExportStatus } from "@constants/Export";
import messages from "./messages.i18n";
export const ExportStatusBanner = ({ status, onRetry, onDismiss, includedCount = 0, skippedCount = 0, errorReason = ExportErrorReason.Generic, errorMessage, }) => {
    const intl = useIntl();
    const theme = useTheme();
    if (status === ExportStatus.Idle)
        return null;
    const isError = status === ExportStatus.Error;
    return (React.createElement(PeekBox, { "data-testid": "export-status-banner", role: "status", "aria-live": "polite", sx: {
            position: "fixed",
            top: theme.spacing(2),
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1400,
            px: 2,
            py: 1.25,
            borderRadius: theme.spacing(1),
            backgroundColor: isError ? alpha(theme.palette.error.main, 0.08) : theme.palette.teal[100],
        } },
        React.createElement(PeekStack, { direction: "row", gap: 1.25, alignItems: "center" },
            status === ExportStatus.Preparing && (React.createElement(PeekCircularProgress, { size: 20, sx: { color: theme.palette.teal[700] } })),
            status === ExportStatus.Success && (React.createElement(CheckCircle, { width: 20, height: 20, style: { color: theme.palette.teal[700] } })),
            isError && React.createElement(AlertTriangle, { width: 20, height: 20, style: { color: theme.palette.error.main } }),
            React.createElement(PeekTypography, { variant: "body1" },
                status === ExportStatus.Preparing &&
                    intl.formatMessage(messages.preparing, { b: (chunks) => React.createElement("b", null, chunks) }),
                status === ExportStatus.Success && (React.createElement(React.Fragment, null,
                    intl.formatMessage(messages.success),
                    skippedCount > 0 &&
                        intl.formatMessage(messages.successPartial, { included: includedCount, skipped: skippedCount }))),
                isError && (React.createElement(React.Fragment, null,
                    errorMessage
                        ? `${errorMessage} `
                        : errorReason === ExportErrorReason.NothingToExport
                            ? intl.formatMessage(messages.nothingToExport)
                            : intl.formatMessage(messages.error),
                    React.createElement(PeekLink, {
                        "data-testid": "export-status-retry",
                        component: "button",
                        type: "button",
                        onClick: onRetry,
                        sx: { cursor: "pointer", textDecoration: "underline" },
                    }, intl.formatMessage(messages.retry))))),
            isError && (React.createElement(PeekIconButton, { "data-testid": "export-status-dismiss", "aria-label": intl.formatMessage(messages.dismiss), bordered: false, size: "small", onClick: onDismiss },
                React.createElement(X, { width: 16, height: 16 }))))));
};
export default ExportStatusBanner;
